
<template lang="pug">
  fieldset.option-select.option-select--buttons
    legend.option-select__legend(v-if="label")
      span.option-select__legend--title {{ label }}
    label.option-select__label(
      v-for="option in optionSet"
      tabindex="0"
      :class="{ 'is-selected': option.value === value }"
      @keyup.space="onChange(option.value)"
      @keydown.space.prevent
    ) {{ option.label }}
      input.u-sr-only(
        type="radio"
        tabindex="-1"
        :id="option.label"
        :value="option.value"
        :checked="option.value === value"
        :disabled="option.disabled"
        :name="option"
        @change="onChange(option.value)"
      )
</template>

<script>
  import TextInput from 'scripts/components/forms/TextInput.vue';

  export default {
    name: 'OptionSelectButtons',
    props: {
      product: Object,
      label: String,
      value: String,
      option: {
        type: String,
        default: 'option1',
        validator (val) {
          return ['option1', 'option2', 'option3'].includes(val);
        },
      },
    },
    data () {
      return {
        currentValue: this.value,
      };
    },
    mounted () {
      let initialValue = this.value && this.value !== '' ? this.value : this.optionSet[0].value;
      this.$emit('input', initialValue);
    },
    computed: {
      optionSet () {
        return [...new Set(this.product.variants.slice().map(variant => variant[this.option]))]
          .map(option => ({ label: option, value: option }));
      },
    },
    watch: {
      currentValue () {
        console.log('OptionSelectButtons currentValue watcher triggered, emitting:', this.currentValue);
        this.$emit('input', this.currentValue);
      },
      value (newVal) {
        console.log('OptionSelectButtons value prop changed to:', newVal);
        this.currentValue = newVal;
      },
    },
    methods: {
      onChange (value) {
        console.log('OptionSelectButtons onChange called with:', value);
        console.log('Current value before:', this.currentValue);
        this.currentValue = value;
        console.log('Current value after:', this.currentValue);
      },
      update (newValue) {
        this.currentValue = newValue;
      },
    },
  };
</script>

<style lang="scss">
</style>
